//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';
import constant from '~/const';
import User from '~/components/User.vue';
import Filters from './UserReferralReferralsFilters.vue';
import UserReferralsEdit from './UserReferralsEdit.vue';
import UserReferralReferralsExtra from './UserReferralReferralsExtra.vue';

import tableConfig from './tableConfig';

export default {
  components: {
    Filters,
    User,
    UserReferralsEdit,
    UserReferralReferralsExtra,
  },

  data() {
    return {
      tableConfig,
      selection: [],
      constant,
      loader: false,
      editModal: {
        show: false,
        data: {},
      },
    };
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapGetters('common', ['itemsPerPage']),

    ...mapState('referrals', ['page', 'pages', 'referrals', 'sort']),

    leadId() {
      return this.$route.params.id;
    },
  },

  methods: {
    ...mapActions('common', ['setGeneralLoader', 'setGeneralProgress', 'setSuccessNotification', 'setErrorNotification']),
    ...mapActions('referrals', {
      loadDataAction: 'loadTraderLeadReferrals',
      editReferralAction: 'editReferral',
      addReferralAction: 'addReferral',
      deleteReferralAction: 'deleteReferral',
      setPageAction: 'setPage',
      setSortAction: 'setSort',
    }),

    applySort(data) {
      this.setSortAction(data);
      this.loadData();
    },

    async referralsUpdate(data) {
      this.setGeneralLoader(true);
      try {
        if (data.leadId) {
          await this.addReferralAction(data);
        } else {
          await this.editReferralAction(data);
        }
        this.editModal.show = true;
        await this.loadData();
        this.setSuccessNotification('Percents updated');
      } catch (error) {
        this.setErrorNotification(error.message);
      }
      this.setGeneralLoader(false);
    },

    openEditModal(row) {
      this.editModal.data = row;
      this.editModal.show = true;
    },

    async loadData() {
      this.setGeneralProgress(true);
      this.loader = true;
      await this.loadDataAction({ leadId: this.leadId });
      this.setGeneralProgress(false);
      this.loader = false;
    },

    applyFilters() {
      const { page } = this;
      if (page > 1) {
        this.setPageAction(1);
        this.$router.replace({ query: {} });
      }

      this.loadData();
    },

    setPage(value) {
      this.setPageAction(value);

      const extendedRequestData = {
        getTotal: false,
      };

      this.loadData(extendedRequestData);
    },

    deleteReferral(id) {
      this.setGeneralLoader(true);
      this.deleteReferralAction(id).then(() => {
        this.setSuccessNotification('Referral deleted');
        this.loadData();
      }).catch((error) => {
        this.setErrorNotification(error.message);
      }).finally(() => {
        this.setGeneralLoader(false);
      });
    },
  },
};
